var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"v-icon__svg",attrs:{"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M6.41,5,17,15.59V11.51h2V19H11.51V17h4.08L5,6.41Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }